<div class="usa-modal maxw-full" id="example-modal-1" aria-labelledby="modal-1-heading" aria-describedby="modal-1-description">
  <form [formGroup]='frtMessageForm'>
    <div class="usa-modal__content">
      <div class="usa-modal__main">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
            <legend class="usa-legend usa-legend--medium" id="modal-1-heading" id="dialog-sizes-name3">
              Message List
            </legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <button class="usa-button usa-modal__close" (click)="cancelMessage()">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="usa-prose grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <h4>Accessorial Service: </h4>
            <p>{{title}}</p>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="message-text" class="usa-label">Enter New Message</label>
                <textarea id="message-text" formControlName="newMessage" class="usa-textarea maxw-full "></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="usa-modal__footer">
          <ul class="usa-button-group">
            <li class="usa-button-group__item">
              <button type="button" [disabled]="redirectedFromBol" class="usa-button" (click)="saveMessage()">
                Save
              </button>
            </li>
            <li class="usa-button-group__item">
              <button type="button" class="usa-button usa-button--outline padding-105 text-center" (click)="cancelMessage()">Cancel</button>
            </li>
          </ul>
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <label for="message-history" class="usa-label">Message History : </label>
              <ul class="usa-list usa-list--unstyled" id="message-history">
                @for (msgHist of messageHistoryArray; track msgHist) {
                  <li>{{msgHist}}</li>
                }
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>